var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "no-results-wrapper" }, [
    _c(
      "div",
      { staticClass: "no-results" },
      [
        _c("span", { staticClass: "icon-ticket no-results__icon" }),
        _vm._v(" "),
        _c("p", { staticClass: "no-results__message" }, [
          _vm._v(_vm._s(_vm.noResultsCopy))
        ]),
        _vm._v(" "),
        _vm.noResultsSecondaryCopy
          ? _c("p", { staticClass: "no-results__secondary-message" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.noResultsSecondaryCopy) +
                  "\n        "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showRedirect
          ? _c(
              "router-link",
              {
                staticClass: "no-results__cta",
                attrs: { tag: "button", to: "/" }
              },
              [
                _vm._v(
                  "\n            " + _vm._s(_vm.redirectCopy) + "\n        "
                )
              ]
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }